import Hero from "@/components/Hero";
import BrandLogos from "@/components/BrandLogos";
import Services from "@/components/Services";
import ProblemsAndSolutions from "@/components/ProblemsAndSolutions";
import TraditionalProductions from "@/components/TraditionalProductions";
import AIProductions from "@/components/AIProductions";
import VideoTestimonials from "@/components/VideoTestimonials";
import ClientFeedbacks from "@/components/ClientFeedbacks";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import Philosophy from "@/components/Philosophy";
import WebseitenShowcase from "@/components/WebseitenShowcase";
import SEO from "@/components/SEO";

const Index = () => {
  return (
    <main className="min-h-screen">
      <SEO 
        title="Videoproduktion Aachen | Imagefilm, Testimonials & KI-Videos | JC Productions"
        description="Professionelle Videoproduktion in Aachen: Imagefilme, Testimonials, Social Media Videos & KI-Produktionen. Klassische Filmproduktion oder innovative KI-Videos ohne Drehtag. Jetzt anfragen!"
        canonical="/"
      />
      <Hero />
      <BrandLogos />
      <Philosophy />
      <Services />
      <ProblemsAndSolutions />
      <TraditionalProductions />
      <AIProductions />
      <WebseitenShowcase />
      <VideoTestimonials />
      <ClientFeedbacks />
      <Contact />
      <Footer />
    </main>
  );
};

export default Index;